import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7721e67c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex align-items-center justify-content-between flex-wrap mb-2" }
const _hoisted_2 = { class: "mb-0" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "mb-1",
  height: "60",
  width: "60"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#icon-wallet" })
], -1))
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "row my-3" }
const _hoisted_6 = { class: "d-flex justify-content-between" }
const _hoisted_7 = {
  key: 0,
  class: "subcard"
}
const _hoisted_8 = { class: "mb-2" }
const _hoisted_9 = { class: "d-flex mb-2" }
const _hoisted_10 = {
  alt: "cadac prepaid icon",
  class: "wallet-icon"
}
const _hoisted_11 = { class: "text-primary mb-0 leading-8" }
const _hoisted_12 = { class: "subcard" }
const _hoisted_13 = { class: "mb-2" }
const _hoisted_14 = { class: "d-flex mb-2" }
const _hoisted_15 = {
  alt: "loyalty discount icon",
  class: "wallet-icon"
}
const _hoisted_16 = { class: "text-primary mb-0 leading-8" }
const _hoisted_17 = { class: "d-flex justify-content-between" }
const _hoisted_18 = { class: "subcard" }
const _hoisted_19 = { class: "mb-2" }
const _hoisted_20 = { class: "d-flex mb-2" }
const _hoisted_21 = {
  alt: "loyalty cashback icon",
  class: "wallet-icon"
}
const _hoisted_22 = { class: "text-primary mb-0 leading-8" }
const _hoisted_23 = { class: "d-flex align-items-center" }
const _hoisted_24 = { class: "text-bold mb-0" }
const _hoisted_25 = { class: "d-flex align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_Card = _resolveComponent("Card")!
  const _component_Message = _resolveComponent("Message")!
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, [
        _hoisted_3,
        _createTextVNode(" " + _toDisplayString(_ctx.vm.title), 1)
      ]),
      (_ctx.vm.walletDepositPageUrl)
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 0,
            class: "p-button-raised p-button-success p-button-arrow",
            label: _ctx.$t('myCadac.walletOverview.button.buyPrepaidCredit'),
            onClick: _cache[0] || (_cache[0] = ($event: any) => {
				_ctx.openUrl(_ctx.vm.walletDepositPageUrl);
				$event.target.disabled = true;
			})
          }, null, 8, ["label"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("p", {
      class: "lead",
      innerHTML: _ctx.vm.introText
    }, null, 8, _hoisted_4),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.vm?.totalDeposited > 0 ? 'col-12 col-lg-12 col-xl-8 mb-1': 'col-12 col-lg-6 mb-1')
      }, [
        _createVNode(_component_Card, {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggleWalletType())),
          id: "wallet-card-1",
          class: _normalizeClass(['wallet-total-card', { 'active-wallet-card': _ctx.cadacWalletTransactionsVisible }])
        }, {
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              (_ctx.vm?.totalDeposited > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('myCadac.walletOverview.t2')), 1),
                    _createElementVNode("div", _hoisted_9, [
                      _withDirectives(_createElementVNode("img", _hoisted_10, null, 512), [
                        [_directive_lazy, '/Static/images/loyalty-gold.png']
                      ]),
                      _createElementVNode("h2", _hoisted_11, _toDisplayString(_ctx.formatCurrency(_ctx.vm?.totalDeposited)), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('myCadac.walletOverview.t1')), 1),
                _createElementVNode("div", _hoisted_14, [
                  _withDirectives(_createElementVNode("img", _hoisted_15, null, 512), [
                    [_directive_lazy, '/Static/images/loyalty-silver.png']
                  ]),
                  _createElementVNode("h2", _hoisted_16, _toDisplayString(_ctx.formatCurrency(_ctx.vm?.totalSaved)), 1)
                ])
              ]),
              _createVNode(_component_RadioButton, {
                onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
                modelValue: _ctx.cadacWalletTransactionsVisible,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.cadacWalletTransactionsVisible) = $event)),
                value: true
              }, null, 8, ["modelValue"])
            ])
          ]),
          _: 1
        }, 8, ["class"])
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.vm?.totalDeposited > 0 ? 'col-12 col-lg-12 col-xl-4 mb-1': 'col-12 col-lg-6 col-xl-6 mb-1')
      }, [
        _createVNode(_component_Card, {
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.toggleWalletType())),
          id: "wallet-card-2",
          class: _normalizeClass(['wallet-total-card', { 'active-wallet-card': !_ctx.cadacWalletTransactionsVisible }])
        }, {
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('myCadac.walletOverview.t3')), 1),
                _createElementVNode("div", _hoisted_20, [
                  _withDirectives(_createElementVNode("img", _hoisted_21, null, 512), [
                    [_directive_lazy, '/Static/images/autodesk-coin.png']
                  ]),
                  _createElementVNode("h2", _hoisted_22, _toDisplayString(_ctx.formatCurrency(_ctx.vm?.totalAutodeskSaved)), 1)
                ])
              ]),
              _createVNode(_component_RadioButton, {
                onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"])),
                modelValue: _ctx.cadacWalletTransactionsVisible,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.cadacWalletTransactionsVisible) = $event)),
                value: false
              }, null, 8, ["modelValue"])
            ])
          ]),
          _: 1
        }, 8, ["class"])
      ], 2)
    ]),
    (!_ctx.tableData?.length)
      ? (_openBlock(), _createBlock(_component_Message, {
          key: 0,
          closable: false,
          severity: "warn"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.cadacWalletTransactionsVisible ? _ctx.$t("myCadac.walletOverview.message.noTransactions") : _ctx.$t("myCadac.walletOverview.message.noAutodeskTransactions")), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.tableData?.length)
      ? (_openBlock(), _createBlock(_component_DataTable, {
          key: 1,
          id: "walletOverviewTable",
          class: "mb-3",
          paginator: _ctx.showPagination,
          "removable-sort": "",
          "responsive-layout": 'scroll',
          "row-class": _ctx.getRowClass,
          rows: _ctx.maxRowsToShow,
          "sort-field": "transactionDate",
          "sort-order": -1,
          value: _ctx.tableData
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              key: "type",
              field: "type",
              header: _ctx.$t('myCadac.walletOverview.table.colType'),
              sortable: true
            }, {
              body: _withCtx((item) => [
                _createElementVNode("div", _hoisted_23, [
                  _createVNode(_component_Avatar, {
                    class: "mr-1 bg-transparent",
                    icon: _ctx.getTransactionIcon(item.data),
                    size: "sm"
                  }, null, 8, ["icon"]),
                  _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.getTransactionText(item.data)), 1)
                ])
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_Column, {
              key: "orderNumber",
              field: "orderNumber",
              header: _ctx.$t('myCadac.walletOverview.table.colOrderNumber')
            }, {
              body: _withCtx((item) => [
                _createElementVNode("span", null, _toDisplayString(item.data.orderNumber), 1)
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_Column, {
              key: "date",
              field: "transactionDate",
              header: _ctx.$t('myCadac.walletOverview.table.colDate'),
              sortable: true
            }, {
              body: _withCtx((item) => [
                _createElementVNode("span", null, _toDisplayString(_ctx.formatDate(item.data.transactionDate)), 1)
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_Column, {
              key: "amount",
              field: "amount",
              header: _ctx.$t('myCadac.walletOverview.table.colTotalAmount'),
              sortable: true
            }, {
              body: _withCtx((item) => [
                _createElementVNode("div", _hoisted_25, [
                  _createVNode(_component_Avatar, {
                    class: "mr-1 bg-transparent text-danger icon-border",
                    icon: _ctx.getAmountIcon(item.data),
                    size: "sm"
                  }, null, 8, ["icon"]),
                  _createElementVNode("span", null, _toDisplayString(_ctx.formatCurrency(item.data.amount)), 1)
                ])
              ]),
              _: 1
            }, 8, ["header"])
          ]),
          _: 1
        }, 8, ["paginator", "row-class", "rows", "value"]))
      : _createCommentVNode("", true)
  ], 64))
}